export const stats = [
  { value: '+540', label: "Unità e Fichè Pronte all'Uso" },
  { value: '+1.500', label: 'Docenti Soddisfatti' },
  { value: '3.800+', label: 'Ore Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+540', label: 'Unità e Attività (1ª Primaria a 3ª Media)' },
  { value: '8', label: 'Volumi Digitali Completi' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a pianificare ogni singola lezione da zero cercando su 10 siti diversi',
  'Esperimenti che falliscono perché non hai i materiali o le istruzioni chiare',
  'Nessuna connessione chiara tra la teoria e il mondo reale',
  'Difficoltà nel creare verifiche adatte a diversi livelli (BES/DSA)',
  'Studenti demotivati che pensano che "la scienza sia noiosa"',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in classe con sicurezza',
  'Laboratori pratici e coinvolgenti con materiali facili da trovare',
  'Infografiche e mappe concettuali integrate in ogni unità',
  'Quiz, verifiche, soluzioni e rubriche già pronti al 100%',
  'Studenti che osservano, sperimentano e capiscono davvero',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: "Ansia da spiegazione: arrivare in classe senza sapere come spiegare un concetto complesso (come la fotosintesi o l'elettricità) in modo semplice",
  },
  {
    emoji: '⏱️',
    text: "Domeniche rubate: passare l'intera domenica a preparare materiali didattici che dovrebbero richiedere minuti",
  },
  {
    emoji: '🤷',
    text: 'Caos creativo: faticare a trovare schede didattiche che siano davvero di alta qualità, visive e moderne',
  },
  {
    emoji: '📋',
    text: 'Valutazione infinita: nessuna rubrica di valutazione chiara o test allineato con il programma ministeriale',
  },
  {
    emoji: '😴',
    text: 'Studenti persi: alunni che restano indietro perché il materiale non è adatto al loro livello o non è inclusivo (BES/DSA)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '8 Volumi basati sull\u2019Anno Scolastico (1ª Primaria – 3ª Media)',
    text: 'Un curriculum scientifico completo: dalla scoperta dei sensi alla tettonica delle placche',
  },
  {
    emoji: '🧪',
    title: 'Kit Laboratorio ed Esperimenti',
    text: 'Schede tecniche per esperimenti pratici da fare in classe, con materiali poveri e spiegazioni passo-passo',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici che ti dicono esattamente cosa dire e come condurre la lezione',
  },
  {
    emoji: '📐',
    title: 'Scienze Visuale: Infografiche e Mappe',
    text: 'Grafiche ad alta risoluzione (8K) che rendono comprensibili i processi invisibili: atomi, cellule, forze',
  },
  {
    emoji: '📊',
    title: 'Verifiche, Soluzioni e BES/DSA',
    text: 'Strumenti di valutazione completi e versioni facilitate per una didattica davvero inclusiva',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Chiavi di Correzione)',
    text: 'Soluzioni complete di ogni esercizio per correzioni istantanee e senza stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mZGQUZeS8vJGZuFHqrL1Tz/Captura-de-pantalla-2026-09-02-a-las-8.26.14_p._m..webp',
    level: '1ª Primaria · Attività',
    title: 'Vivo o Non Vivo?',
    caption:
      'Scheda pronta da stampare: dieci immagini da classificare con caselle da spuntare, ideale per i primi passi nel metodo scientifico.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eEN8C57qTnwozWmLQPfQML/Captura-de-pantalla-2026-09-02-a-las-8.30.06_p._m..webp',
    level: '2ª Primaria · Infografica',
    title: 'Il cuore, il motore della circolazione',
    caption:
      'Tavola anatomica con atri, ventricoli e il percorso del sangue, più una scheda dati e lo schema del circuito completo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bt3nafEFcxbsH9kmhdQuXN/Captura-de-pantalla-2026-09-02-a-las-8.28.07_p._m..webp',
    level: '5ª Primaria · Attività',
    title: 'Classifica la materia: solido, liquido o gassoso',
    caption:
      "Dodici elementi reali da osservare e classificare, con legenda a colori e suggerimento didattico per l'insegnante.",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ouckRGfmYrKUNKq7C3YAL9/Captura-de-pantalla-2026-09-02-a-las-8.28.31_p._m..webp',
    level: '5ª Primaria · Attività',
    title: 'Classifica le forme di energia',
    caption:
      'Sei immagini illustrate da riconoscere e nominare, con nota per il docente sulle dieci immagini complete nel workbook.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6KXxd9AnvDGcaAmmag6C2T/Captura-de-pantalla-2026-09-02-a-las-8.27.18_p._m..webp',
    level: '1ª Media · Attività',
    title: 'Che tipo di precipitazione?',
    caption:
      'Pioggia, neve, grandine e nebbia a confronto con risposte già corrette e la chiave di correzione in fondo alla pagina.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aWSCAmiKouogPLbc4gjDWh/Captura-de-pantalla-2026-09-02-a-las-8.31.00_p._m..webp',
    level: '2ª Media · Esperimento',
    title: 'Effetto della temperatura sulla dissoluzione',
    caption:
      'Scheda di laboratorio completa: domanda, ipotesi, variabili indipendenti e di controllo, lista materiali e procedura passo-passo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nsAKPsckDZYXVt5QsuTvg2/Captura-de-pantalla-2026-09-02-a-las-8.34.11_p._m..webp',
    level: '2ª Media · Infografica',
    title: '4 tipi di vulcani: forme diverse, pericoli diversi',
    caption:
      'Scudo, stratificato, caldera e fango a confronto con foto reali, caratteristiche, esempi noti e livello di pericolo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ddg2Lghfh3iXkNPsGRTdW2/Captura-de-pantalla-2026-09-02-a-las-8.33.45_p._m..webp',
    level: '3ª Media · Attività',
    title: 'Usa F = m × a',
    caption:
      'Due problemi svolti passo per passo (formula, sostituzione, risultato) e due da completare in autonomia.',
  },
]

export const bonuses = [
  {
    title: 'Planner Pronto «Settimana di Scienze Senza Stress»',
    was: '€19',
    text: 'Addio disorganizzazione cronica e alla sensazione che il programma non finisca mai',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/950486b4-786a-4fec-b7ca-fc32030ef203.jpg',
  },
  {
    title: 'Kit Aula «Angolo dello Scienziato»',
    was: '€27',
    text: 'Guida al design educativo e materiali di allestimento per aule vive e motivanti',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d3211a42-cea1-4320-b7aa-c3e8e8eea926.jpg',
  },
  {
    title: 'Script Pronti «Lezioni di Scienze Senza Improvvisare»',
    was: '€36',
    text: 'Mai più la paura di restare senza parole davanti a un concetto difficile',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/2103cd85-8bf6-4bc0-a50b-0923f619c5c2.jpg',
  },
  {
    title: 'Quick Check «Capito Davvero?»',
    was: '€17',
    text: 'Verifiche brevi che ti dicono subito se stanno imparando, senza correzioni infinite',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0f699c53-11f4-4888-9534-54acf40eb37a.jpg',
  },
  {
    title: 'Guida Sprint «5 Minuti e Sei Pronta»',
    was: '€17',
    text: 'Onboarding strategico: non ti senti più sommersa da 600+ pagine di contenuti',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/563acd4f-0b08-494c-98ef-319ab13ad95f.jpg',
  },
]

export const offerRows = [
  { label: 'SCIENZE PRONTA™ Pack (8 Volumi Digitali)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€116' },
]

export const testimonials = [
  {
    quote:
      'Ho finalmente recuperato le mie serate. I laboratori sono semplici da realizzare e i bambini li adorano.',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Le mappe visuali sono una manna dal cielo per i miei alunni DSA. Materiale professionale e pronto all'uso.",
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
  {
    quote:
      "Dalla prima elementare alle medie, è l'unico investimento che serve a un insegnante di scienze.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: "Immediatamente via email in formato PDF dopo l'acquisto.",
  },
  {
    q: 'Funziona per le medie?',
    a: 'Sì, il pacchetto include volumi specifici per la scuola secondaria di primo grado.',
  },
  {
    q: 'È adatto per alunni BES/DSA?',
    a: 'Assolutamente, ogni unità include schemi semplificati e font leggibili.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'No. Paghi una volta e ricevi aggiornamenti a vita.',
  },
]
